import { render, staticRenderFns } from "./CoinsTitle.vue?vue&type=template&id=17c05734&scoped=true&"
import script from "./CoinsTitle.vue?vue&type=script&lang=ts&"
export * from "./CoinsTitle.vue?vue&type=script&lang=ts&"
import style0 from "./CoinsTitle.vue?vue&type=style&index=0&id=17c05734&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c05734",
  null
  
)

export default component.exports